/* COZZYDEPT.: Newsletter- und Benachrichtigungs-Formulare ohne Neuladen absenden (kein Sprung nach oben).
   Shopifys Spam-Schutz (hCaptcha) hält das Absenden an und ruft danach form.submit() auf. Dieser Aufruf
   wird in snippets/cozzy-head.liquid an window.czAjaxSubmit umgeleitet, der Spam-Schutz bleibt also aktiv. */
(function () {
  if (!window.fetch || !window.FormData || !window.DOMParser) return;

  function isCozzyCustomerForm(form) {
    var type = form.querySelector('input[name="form_type"]');
    return !!(form.closest('.cz') && type && type.value === 'customer');
  }

  function nativeSubmit(form) {
    form.dataset.czNative = '1';
    if (window.czNativeSubmit) window.czNativeSubmit(form);
    else HTMLFormElement.prototype.submit.call(form);
  }

  function showMessage(form, text, ok) {
    var msg = form.querySelector('.cz-form-msg');
    if (!msg) {
      msg = document.createElement('p');
      form.appendChild(msg);
    }
    msg.className = 'cz-form-msg' + (ok ? ' is-ok' : '');
    msg.setAttribute('role', ok ? 'status' : 'alert');
    msg.textContent = text;
  }

  function ajaxSubmit(form) {
    if (form.dataset.czBusy) return;
    form.dataset.czBusy = '1';
    form.classList.add('is-sending');
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;

    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (response) {
        var url = new URL(response.url, location.href);
        // Shopify will eine Sicherheitsabfrage zeigen: dann ganz normal absenden
        if (url.pathname.indexOf('/challenge') === 0) {
          nativeSubmit(form);
          return null;
        }
        return response.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = form.id ? doc.getElementById(form.id) : null;
          var freshMsg = fresh ? fresh.querySelector('.cz-form-msg') : null;
          var ok = url.searchParams.get('customer_posted') === 'true' || (freshMsg && freshMsg.classList.contains('is-ok'));
          var text = freshMsg ? freshMsg.textContent.trim() : '';
          if (ok) {
            showMessage(form, text || form.dataset.czSuccess || 'Du bist auf der Liste.', true);
            form.reset();
            form.classList.add('is-done');
          } else {
            showMessage(form, text || 'Das hat nicht geklappt. Bitte prüfe deine E-Mail-Adresse.', false);
          }
        });
      })
      .catch(function () {
        nativeSubmit(form);
      })
      .finally(function () {
        delete form.dataset.czBusy;
        form.classList.remove('is-sending');
        if (button) button.disabled = false;
      });
  }

  window.czAjaxSubmit = function (form) {
    if (!isCozzyCustomerForm(form)) return false;
    ajaxSubmit(form);
    return true;
  };

  // Ohne Spam-Schutz (oder wenn er schon durch ist) direkt hier abfangen
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !(form instanceof HTMLFormElement) || !isCozzyCustomerForm(form)) return;
    event.preventDefault();
    ajaxSubmit(form);
  });
})();
